import { PromoBannerType } from "@faire/deprecated-retailer-visitor-shared/components/Notifications/PromoBanner/bannerOrder";
import { route as amexRoute } from "@faire/web-api--source/routes/www/amex";
import { route as brandApplicationRoute } from "@faire/web-api--source/routes/www/apply";
import { route as brandAdApplicationRoute } from "@faire/web-api--source/routes/www/apply/ad";
import { route as brandInvoiceTokenRoute } from "@faire/web-api--source/routes/www/brand-invoice/brandInvoiceToken";
import { route as messagesRoute } from "@faire/web-api--source/routes/www/messages";
import { route as messagesWithOtherPartyRoute } from "@faire/web-api--source/routes/www/messages/otherPartyToken";
import { route as collectionRoute } from "@faire/web-api--source/routes/www/product-based-collection/product_based_collection_token";
import { route as productRoute } from "@faire/web-api--source/routes/www/product/productToken";
import { route as brandReferralsRoute } from "@faire/web-api--source/routes/www/user/brand-referrals";
import { parseQueryParams } from "@faire/web/common/query-params/parseQueryParams";
import { RetailerRoute } from "@faire/web/common/routes/RetailerRouteMatcher";
import { pathMatchesRoute } from "@faire/web/common/routes/RouteMatcher";
import some from "lodash/some";

const ROUTE_BLACKLIST: RetailerRoute[] = [
  brandApplicationRoute,
  brandAdApplicationRoute,
  messagesRoute,
  messagesWithOtherPartyRoute,
  brandInvoiceTokenRoute,
  brandReferralsRoute,
];

export const getLoggedOutPromoBanners = (options: {
  location: Location;
  isBrandPreviewAndBrandIsInactive?: boolean;
  isFaireMarketPreshowOrLive?: boolean;
  isSpecialHolidayNet90Active?: boolean;
}): PromoBannerType[] => {
  const {
    location,
    isBrandPreviewAndBrandIsInactive,
    isFaireMarketPreshowOrLive,
    isSpecialHolidayNet90Active,
  } = options;
  const queryParams = parseQueryParams(location.search);
  const isAppMobileWebView = queryParams.get("native_env") === "true";
  const isBlacklisted = some(ROUTE_BLACKLIST, (route) =>
    pathMatchesRoute(location.pathname, route)
  );
  // FD-114601: Most banners should not be visible in app mobile view
  //   to prevent user from escaping into the rest of website
  if (isBlacklisted || isAppMobileWebView) {
    return [];
  }
  // Brand preview banner, should override any banner meant for retailers
  else if (isBrandPreviewAndBrandIsInactive) {
    return [PromoBannerType.BRAND_PREVIEW];
  }
  // if Faire Market is active, only show the countdown banner
  else if (isFaireMarketPreshowOrLive) {
    return [PromoBannerType.MARKET_COUNTDOWN];
    // Otherwise, cycle through logged-out banners
  } else {
    const banners = [];
    if (isSpecialHolidayNet90Active) {
      banners.push(PromoBannerType.SPECIAL_HOLIDAY_NET90);
    }
    if (
      !(
        pathMatchesRoute(location.pathname, productRoute) ||
        pathMatchesRoute(location.pathname, collectionRoute)
      )
    ) {
      banners.push(PromoBannerType.BRANDS_COUNTER);
    }
    if (pathMatchesRoute(location.pathname, amexRoute)) {
      banners.push(PromoBannerType.AMEX_INCENTIVE);
    }
    return banners;
  }
};
